import {Injectable} from "@angular/core";
import * as pako from "pako";

@Injectable({
  providedIn: 'root'
})
export class CompressionService {

    decompressBase64(data: string): string {
      const binData = atob(data);
      const charData = binData.split('').map(char => char.charCodeAt(0));
      const zlibData = new Uint8Array(charData);
      return pako.inflate(zlibData, {to: 'string'});
    }
}
